var exports = {
  "i": "xaee3c4fa--76ff68--wrapper",
};

module.exports = exports;
